import {Component, OnInit} from '@angular/core';
import {MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {Observable} from 'rxjs';
import {ProleisObject, SupplierAddress, SupplierContactsService} from "@proleis/proleis-rest-client";

@Component({
  selector: 'ps-create-address',
  templateUrl: 'create-address.component.html'
})
export class CreateAddressComponent implements OnInit {

  address: SupplierAddress;
  addressTypes$: Observable<ProleisObject[] | undefined>;
  countries$: Observable<ProleisObject[] | undefined>;

  constructor(private bs: MatBottomSheetRef, private service: SupplierContactsService) {
    this.address = {
      city: '',
      street: '',
      typeId: '',
      poBox: '',
      description: '',
      countryId: '',
      poastalCode: ''
    };
  }

  ngOnInit() {
    this.addressTypes$ = this.service.getAddressTypes();
    this.countries$ = this.service.getCountries();
  }

  save() {
    this.bs.dismiss(this.address);
  }

  dismiss() {
    this.bs.dismiss(null);
  }

}
